// src/pages/hr/HRPerformance.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRPerformance() {
  return (
    <HRComingSoon
      icon="🎯"
      title="Performance Management"
      description="Set OKRs, run appraisal cycles, manage 360° feedback, PIPs, and track promotions across departments. Coming soon."
    />
  );
}
